export const PakleanImages = {
    mapMove: require('../assets/images/mapmove.png'),

    vanGreen: require('../assets/images/van_green.png'),
    vanBlue: require('../assets/images/van_blue.png'),
    vanBlack: require('../assets/images/van_black.png'),
    vanOrange: require('../assets/images/van_orange.png'),
    vanRed: require('../assets/images/van_red.png'),
    vanNavy: require('../assets/images/van_navy.png'),
    vanViolet: require('../assets/images/van_violet.png'),
    vanPink: require('../assets/images/van_pink.png'),
    vanMaroon: require('../assets/images/van_maroon.png'),
    vanYellow: require('../assets/images/van_yellow.png'),
    vanLalic: require('../assets/images/van_lalic.png'),
    vanSG: require('../assets/images/van_sg.png'),
    vanYP:  require('../assets/images/van_yellow_por.png'),
    vanZZ:  require('../assets/images/van_zereshki_zesht.png'),
    vanGL:  require('../assets/images/van_green_lajani.png'),
    vanP:  require('../assets/images/van_pesteh.png'),
    vanNew01: require('../assets/images/van_color_new01.png'),
    vanNew02: require('../assets/images/van_color_new02.png'),

    laundryGreen: require('../assets/images/laundry_Green.png'),
    laundryBlue: require('../assets/images/laundry_blue.png'),
    laundryBlack: require('../assets/images/laundry_Black.png'),
    laundryOrange: require('../assets/images/laundry_Orange.png'),
    laundryRed: require('../assets/images/laundry_red.png'),
    laundryNavy: require('../assets/images/laundry_Navy.png'),
    laundryViolet: require('../assets/images/laundry_Violet.png'),
    laundryPink: require('../assets/images/laundry_Pink.png'),
    laundryMaroon: require('../assets/images/laundry_Maroon.png'),
    laundryYellow: require('../assets/images/laundry_Yellow.png'),
    laundryLalic: require('../assets/images/laundry_lalik.png'),
    laundrySG: require('../assets/images/laundry_SG.png'),
    laundryYP:  require('../assets/images/laundry_Yellow_POR.png'),
    laundryZZ:  require('../assets/images/laundry_Zereshki_Zesht.png'),
    laundryGL:  require('../assets/images/laundry_Green_Lajani.png'),
    laundryDone:  require('../assets/images/laundry_Gray.png'),
    laundryP:  require('../assets/images/laundry_Pesteh.png'),
    laundryNew01: require('../assets/images/laundry_new_01.png'),
    laundryNew02: require('../assets/images/laundry_new_02.png'),

    deliverBlue: require('../assets/images/deliver_blue.png'),
    deliverGreen: require('../assets/images/deliver_green.png'),
    deliverRed: require('../assets/images/deliver_red.png'),
    deliverViolet: require('../assets/images/deliver_violet.png'),
    deliverPink: require('../assets/images/deliver_pink.png'),
    deliverOrange: require('../assets/images/deliver_orange.png'),
    deliverNavy: require('../assets/images/deliver_navy.png'),
    deliverMaroon: require('../assets/images/deliver_maroon.png'),
    deliverYellow: require('../assets/images/deliver_yellow.png'),
    deliverBlack: require('../assets/images/deliver_black.png'),
    deliverLalic: require('../assets/images/deliver_lalic.png'),
    deliverSG: require('../assets/images/deliver_sg.png'),
    deliverP: require('../assets/images/deliver_pesteh.png'),
    deliverNew01: require('../assets/images/deliver_new01.png'),
    deliverNew02: require('../assets/images/deliver_color_new02.png'),

    deliverYP:  require('../assets/images/deliver_yellow_por.png'),
    deliverZZ:  require('../assets/images/deliver_zereshki_zesht.png'),
    deliverGL:  require('../assets/images/deliver_green_lajani.png'),

    deliverDone: require('../assets/images/deliver_done.png'),
    dot: require('../assets/images/dot.png')


}
